import React from "react";
import ReactDOM from "react-dom";
import "./styles.scss";

import App from './App'

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
